// File: cgp-app-bar.module.ts
// Author: Joseph M Diaz
// Date: 5/11/2017
// Desc: CGP App Bar that has the company logo, navigation toggle, and user menu toggle.
// Other Contributors:

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

import { CgpAppBarService } from './cgp-app-bar.service';
import { CgpAppBarComponent } from './cgp-app-bar.component';
import { CgpAppBarMenuModule } from './cgp-app-bar-menu/cgp-app-bar-menu.module';

@NgModule({
    imports: [
        CommonModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        CgpAppBarMenuModule,
    ],
    exports: [
        CgpAppBarComponent
    ],
    declarations: [
        CgpAppBarComponent
    ],
    providers: [
        CgpAppBarService
    ]
})
export class CgpAppBarModule { }
